export default __webpack_public_path__ + "static/media/n2.a4e17216.jpeg";